import ScrollFadeIn from "./Scrollfadein";
import { useIsMobile } from "./Useismobile";


import Dave from "../assets/Dave1.jpg"

export default function About({ theme }) {
  const { fg, muted, border, accent } = theme;
  const isMobile = useIsMobile();

  const interests = ["Gaming 🎮", "Basketball 🏀", "Anime ✨", "Travel 🌍"];

  const socials = [
    { label: "GITHUB",   href: "https://github.com/DaveInnovator" },
    { label: "LINKEDIN", href: "https://www.linkedin.com/in/david-olarinde-614930386" },
    { label: "TWITTER",  href: "https://x.com/lanreisnotakid" },
  ];

  return (
    <section style={{ padding: isMobile ? "40px 20px" : "60px 40px", maxWidth: 1200, margin: "0 auto" }}>
      <ScrollFadeIn>
        <div style={{ height: 1, background: border, marginBottom: isMobile ? 28 : 40 }} />
      </ScrollFadeIn>

      <ScrollFadeIn delay={0.05}>
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: isMobile ? 40 : 72,
          alignItems: "start",
        }}>

          {/* ── About + interests ── */}
          <div>
            <span style={{ fontSize: 10, letterSpacing: "0.2em", color: muted, display: "block", marginBottom: 20 }}>
              ABOUT ME
            </span>
            <p style={{ fontSize: 13, lineHeight: 1.9, color: muted, marginBottom: 16 }}>
              I'm David — a Frontend Developer, beginner UI/UX Designer, and certified Product Manager
              (Udemy) based in Ibadan, Nigeria. I bring a multidisciplinary perspective to every project:
              I can write the code, design the experience, and think through the product strategy.
            </p>
            <p style={{ fontSize: 13, lineHeight: 1.9, color: muted }}>
              I use AI and prompt engineering to accelerate delivery — rapid prototyping, intelligent
              code generation — while keeping full creative control. Open to full-time remote roles
              and freelance collaborations.
            </p>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 28 }}>
              {interests.map((item) => (
                <span key={item} style={{
                  fontSize: 11, padding: "6px 14px",
                  border: `1px solid ${border}`, borderRadius: 100, color: muted,
                }}>
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* ── Contact ── */}
          <div>
            <span style={{ fontSize: 10, letterSpacing: "0.2em", color: muted, display: "block", marginBottom: 20 }}>
              CONTACT
            </span>

            <div style={{ marginBottom: 20 }}>
              <a
                href="tel:+2347016467560"
                style={{
                  display: "block",
                  fontSize: isMobile ? 15 : 18,
                  fontWeight: 500, color: fg,
                  textDecoration: "none", marginBottom: 8, transition: "color 0.2s",
                }}
                onMouseEnter={e => e.currentTarget.style.color = accent}
                onMouseLeave={e => e.currentTarget.style.color = fg}
              >
                +234 701 646 7560
              </a>
              <a
                href="mailto:olarindedavid49@gmail.com"
                style={{
                  display: "block",
                  fontSize: isMobile ? 13 : 18,
                  fontWeight: 500, color: fg,
                  textDecoration: "none", transition: "color 0.2s",
                  wordBreak: "break-all",
                }}
                onMouseEnter={e => e.currentTarget.style.color = accent}
                onMouseLeave={e => e.currentTarget.style.color = fg}
              >
                olarindedavid49@gmail.com
              </a>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 20 }}>
              {socials.map(({ label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    padding: "8px 18px", fontSize: 10, letterSpacing: "0.13em",
                    border: `1px solid ${border}`, borderRadius: 100,
                    color: muted, textDecoration: "none", transition: "all 0.2s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = fg; e.currentTarget.style.color = fg; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = border; e.currentTarget.style.color = muted; }}
                >
                  {label} ↗
                </a>
              ))}
            </div>

            {/* Photo — hide on mobile to save space */}
            {!isMobile && (
              <div style={{
                width: 140, height: 140, borderRadius: "50%",
                overflow: "hidden", border: `2px solid ${border}`, marginTop: 36,
              }}>
                <img
                  src={Dave}
                  alt="David"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  draggable={false}
                />
              </div>
            )}
          </div>
        </div>
      </ScrollFadeIn>
    </section>
  );
}